import React from "react";
import PropTypes from "prop-types";

const StoreHeading = ({ renderHeading = () => {} }) => renderHeading();

StoreHeading.propTypes = {
    renderHeading: PropTypes.func.isRequired,
};

const StoreHeadingControl = ({ renderHeading }) => (
    <div className="grid">
        {/* Keep spacing above and below RegistrationContent consistent */}
        <div className="col col--12  -padding-top--30">
            <StoreHeading renderHeading={renderHeading} />
        </div>
    </div>
);

StoreHeadingControl.propTypes = {
    renderHeading: PropTypes.func.isRequired,
};

export default StoreHeadingControl;
